import { j as s } from "./index13.mjs";
import { h as i, E as m, c as n } from "./index14.mjs";
import "react";
import "./index15.mjs";
function j(o, r, t) {
  return i.call(r, "css") ? s.jsx(m, n(o, r), t) : s.jsx(o, r, t);
}
export {
  j as jsx
};
